'use strict';

import jQuery from 'jquery';
import viralEmbedCodeTemplate from './views/coveViralEmbed.hbs';

var ViralEmbed = (function($) {

  // Namespace for private variables and functions
  var privateNS = {
    defaults: { // Namespace for default options
      width: 512,
      height: 376,
      aspectRatio: 0.734375,
      tpMediaObjectId: ''
    }
  };

  /**
   * Initializes a ViralEmbed box. Handles the UI interactions of the COVE
   * viral embed element
   *
   * @param {object} options Params: container => The container of the embed ui
   * @constructor
   */
  function ViralEmbed(options) {

    // Initialize options
    this._options = $.extend({}, privateNS.defaults, options);

    // Create a reference to the UI container
    this.setContainer(this._options.container);

    // If a tp media object id was not passed in, check the container for one
    if (!this._options.tpMediaObjectId &&
        this._$container.find('.embed-code').attr('data-tp-media-object-id')) {
      this._options.tpMediaObjectId = this._$container.find('.embed-code').attr('data-tp-media-object-id');
    }

    // Initialize the element
    this._bind();
  }

  ViralEmbed.prototype.destroy = function destroy() {

    if (this._$container && this._$container.length > 0) {
      this._$container.off();
    }
  };

  ViralEmbed.prototype.setContainer = function setContainer($container) {
    this.destroy();
    this._$container = $container;
  };

  ViralEmbed.prototype.getInputWidth = function getInputWidth() {
    return this._options.width;
  };

  ViralEmbed.prototype.setInputWidth = function setInputWidth(width) {
    this._options.width = width;
  };

  ViralEmbed.prototype.getInputHeight = function getInputHeight() {
    return this._options.height;
  };

  ViralEmbed.prototype.setInputHeight = function setInputHeight(height) {
    this._options.height = height;
  };

  ViralEmbed.prototype.getTPMediaObjectId = function getTPMediaObjectId() {
    return this._options.tpMediaObjectId;
  };

  ViralEmbed.prototype.setTPMediaObjectId = function setTPMediaObjectId(tpMediaObjectId) {
    this._options.tpMediaObjectId = tpMediaObjectId;
  };

  ViralEmbed.prototype.render = function render() {

    this._$container.find('.embed-code').html(
      viralEmbedCodeTemplate({
        width: this._options.width,
        height: this._options.height,
        tpMediaObjectId: this._options.tpMediaObjectId
      })
    );
  };

  ViralEmbed.prototype._onUpdateEmbedWidthControl = function _onUpdateEmbedWidthControl() {
    var width = this._$container.find('.embed-width-control').val() || 0,
        height = Math.floor(width * this._options.aspectRatio);

    this._$container.find('.embed-height-control').val(height);
    this._updateEmbedDimensions(width, height);
  };

  ViralEmbed.prototype._onUpdateEmbedHeightControl = function _onUpdateEmbedWidthControl() {
    var height = this._$container.find('.embed-height-control').val() || 0,
        width = Math.floor(height / this._options.aspectRatio);

    this._$container.find('.embed-width-control').val(width);
    this._updateEmbedDimensions(width, height);
  };

  ViralEmbed.prototype._updateEmbedDimensions = function _updateEmbedDimensions(width, height) {
    this.setInputWidth(width);
    this.setInputHeight(height);

    this.render();
  };

  ViralEmbed.prototype._bind = function _bind() {

    this.destroy();

    if (this._$container) {

      this._$container.on(
        'keyup change blur',
        '.embed-width-control',
        this._onUpdateEmbedWidthControl.bind(this)
      );

      this._$container.on(
        'keyup change blur',
        '.embed-height-control',
        this._onUpdateEmbedHeightControl.bind(this)
      );
    }
  };

  return ViralEmbed;
})(jQuery);

export default ViralEmbed